var my_product_info = "";
var my_options = "";
var my_items = "";
shopify_cart();
setInterval("verify_cart()", 3600000);

$(document).on("click", ".product-opt-title", function (e) {
  e.preventDefault();
  if ($(this).parents(".product-opt-part").hasClass("product-opt-part-open")) {
    $(this).parents(".product-opt-part").removeClass("product-opt-part-open");
  } else {
    $(".product-opt-part").removeClass("product-opt-part-open");
    $(this).parents(".product-opt-part").addClass("product-opt-part-open");
  }
});

$(document).on("click", ".add-to-cart-wc", function (e) {
  e.preventDefault();
  debugger;
  var form_id = $(this).parents("form").attr("id");
  if (my_product_info.length > 0) {
    var total_length = $(".product-opt-element-app input:checked").length;
    var limit_items = my_product_info[0].limit_items;
    console.log(total_length);
    if (total_length == limit_items) {
      setTimeout(function () {
        addItem(form_id);
      }, 1000);
    } else {
      alert("Choose " + limit_items + " items for your own custom box");
      return false;
    }
  } else {
    setTimeout(function () {
      addItem(form_id);
    }, 1000);
  }
});

$(document).on("click", ".product-opt-value-app input", function () {
  var id_option = $(this).data("option");
  verify_option(id_option);
});

function product_app(id) {
  var url = "https://mypaddybox.com/api/store/product";
  var type = "GET";
  $.ajax({
    type: type,
    url: url,
    data: {
      id: id,
    },
    dataType: "json",
    success: function (data) {
      console.log(data);
      var product_info = "";
      my_product_info = data.product_info;
      my_options = data.options;
      my_items = data.items_options;
      var form_id = $(".product-single__form").attr("id");
      var checked_input = "";
      var class_items = "";
      var readonly_items = "";
      
      if (data.product_info.length > 0) {
        product_info +=
          "<h2>Choose " +
          data.product_info[0].limit_items +
          " items for your product</h2>";
      }
      
      if (my_items.length > 0) {
        var options = data.options;
 
        var items_options = data.items_options;
        if (options.length > 0) {
          for (i = 0; i < options.length; i++) {
            var product_items = "";
            var class_open = "";
            var limit_option = "";
            for (d = 0; d < items_options.length; d++) {
              if (my_product_info.length == 0 && options[i].limit_select == 0) {
                checked_input = 'checked = "checked"';
                class_items = "items-hidden";
              }

              if (options[i].type == 3) {
                checked_input = 'checked = "checked"';
                class_items = "items-hidden";
                readonly_items = "disabled-items";
              }

              if (items_options[d].id_option == options[i].id) {
                product_items +=
                  '<span class="product-opt-element-app">\
                          <span class="product-opt-value-app">\
                            <input type="checkbox" ' +
                  checked_input +
                  ' form="' +
                  form_id +
                  '" value="Item N-' +
                  items_options[d].item_data.id +
                  '" id="' +
                  items_options[d].item_data.id +
                  '" class="option-' +
                  items_options[d].id_option +
                  '" name="properties[' +
                  items_options[d].item_data.title +
                  ']" data-option="' +
                  items_options[d].id_option +
                  '">\
                            <label for="' +
                  items_options[d].item_data.id +
                  '">\
                              <span class="product-opt-value-title-app">' +
                  items_options[d].item_data.title +
                  "</span>\
                            </label>\
                          </span>\
                        </span>";
              }
            }

            if (product_items == "") {
              product_items =
                '<span class="product-opt-element-app text-center">There are no items linked to this option</span>';
            }

            if (i == 0) {
              class_open = "product-opt-part-open";
            }

            if (options[i].limit_select > 0) {
              limit_option = "(" + options[i].limit_select + " item max)";
            }

            if (options[i].type == 1) {
              product_info +=
                '<div class="product-opt-part ' +
                class_open +
                " " +
                class_items +
                '" id="div-option-' +
                options[i].id +
                '">\
                            <span class="product-opt-title"> ' +
                options[i].title +
                " " +
                limit_option +
                '<span class="acco-arrow"></span></span>\
                            <div class="product-opt-element-part">\
                                    ' +
                product_items +
                "\
                            </div>\
                        </div>";
            } else if (options[i].type == 3) {
              product_info +=
                '<div class="product-opt-part ' +
                class_open +
                " " +
                readonly_items +
                '" id="div-option-' +
                options[i].id +
                '">\
                            <span class="product-opt-title"> ' +
                options[i].title +
                " " +
                limit_option +
                '<span class="acco-arrow"></span></span>\
                            <div class="product-opt-element-part">\
                                    ' +
                product_items +
                "\
                            </div>\
                        </div>";
            } else {
              product_info +=
                '<div class="product-opt-part-default ' +
                class_items +
                '" id="div-option-' +
                options[i].id +
                '">\
                            <span class="product-opt-title"> ' +
                options[i].title +
                " " +
                limit_option +
                '</span>\
                            <div class="product-opt-element-part">\
                                    ' +
                product_items +
                "\
                            </div>\
                        </div>";
            }
          }
        }
        $("#product_app_data").html(product_info);
      }
    },
    error: function (data) {},
  });
}

function verify_option(id_option) {
  for (i = 0; i < my_options.length; i++) {
    if (id_option == my_options[i].id) {
      if (my_options[i].limit_select != 0) {
        var total_option = 0;
        $(".product-opt-value-app .option-" + id_option).each(function () {
          if ($(this).is(":checked")) {
            total_option++;
          }
        });

        if (total_option == my_options[i].limit_select) {
          $("#div-option-" + id_option).addClass("product-part-hide-wc-app");
        } else {
          $("#div-option-" + id_option).removeClass("product-part-hide-wc-app");
        }
        //console.log(total_option);
      }
    }
  }
  verify_product();
}

function verify_product() {
  if (my_product_info.length > 0) {
    var limit_items = my_product_info[0].limit_items;
    if (limit_items != 0) {
      var total_option = 0;
      $(".product-opt-value-app input").each(function () {
        if ($(this).is(":checked")) {
          total_option++;
        }
      });

      console.log(my_product_info);

      if (total_option == limit_items) {
        $("#product_app_data").addClass("product-part-hide-wc-app");
        alert("You have selected the maximum amount of items.");
      } else {
        $("#product_app_data").removeClass("product-part-hide-wc-app");
      }
    }
  }
}

function addItem(form_id) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: $("#" + form_id).serialize(),
    success: function (data) {
      window.location.href = "/cart";
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log("error");
    },
  });
}

function shopify_cart() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (data) {
      if (data.items.length > 0) {
        verify_cart(data);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      //console.log('error');
    },
  });
}

function verify_cart(items) {
  //console.log(items);
  $.ajax({
    type: "POST",
    url: "https://mypaddybox.com/api/store/cart",
    dataType: "json",
    data: items,
    success: function (data) {
      if (data.items.length > 0) {
        remove_cart(data.items);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log("error");
    },
  });
}

function remove_cart(items) {
  //console.log(items);
  for (i = 0; i < items.length; i++) {
    var id = items[i].id;
    $.ajax({
      type: "GET",
      url: "/cart/change?id=" + id + "&quantity=0",
      dataType: "json",
      data: items,
      success: function (data) {
        //console.log(data);
      },
      error: function (XMLHttpRequest, textStatus) {
        //console.log('error');
      },
    });
  }
}
